<template lang="pug">
  .mobile-subnav-tiles
    .mobile-subnav-tiles__tile(
      v-for="tile, index in tiles"
      :is="tile.link ? 'a' : 'div'"
      :href="tile.link"
      :key="`${tile.headin}_${index}`"
    )
      img(
        v-if="tile.image"
        :src="tile.image.src"
        :alt="tile.image.alt"
      )
      .mobile-subnav__tile-heading {{ tile.heading }}
</template>

<script>
  import MobileSubnav from 'scripts/components/site-header/MobileSubnav.vue';

  export default {
    name: 'MobileSubnavTiles',
    extends: MobileSubnav,
    props: { }
  }
</script>

<style scoped lang="scss">
  .mobile-subnav-tiles {
    padding: ($spacing-unit * 10) ($spacing-unit * 19)
  }

  .mobile-subnav-tiles__tile {
    display: block;
    margin-bottom: ($spacing-unit * 8);
  }

  .mobile-subnav__tile-heading {
    color: $color-black;
    font-size: rem(24px);
    line-height: rem(31px);
    text-align: center;
  }
</style>
